import SectionMessage from '@atlaskit/section-message';
import Link from '@atlaskit/link';
import { Code } from '@atlaskit/code';
import * as React from 'react';
export default {
  SectionMessage,
  Link,
  Code,
  React
};